module.exports = __webpack_public_path__ + "static/media/HoHoHo.c9226104.mp3";